export default __webpack_public_path__ + "static/media/Time.6f5ac932.svg";